module.exports = __webpack_public_path__ + "img/ambassador-4.de55ddb0.png";